"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchMobile = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const shared_1 = require("../../shared");
const atoms_1 = require("../atoms");
const Search_1 = require("./Search");
const Styled = styled_components_1.default.div `
	width: 100%;
	padding: 24px;
	text-align: center;

	${(p) => p.theme.breakpoints.down("xs")} {
		padding: 16px;
	}

	.extension {
		max-width: 375px;
		margin: 0 auto;
		background: ${(p) => p.theme.palette.background.default};
		text-align: left;

		${(p) => p.theme.breakpoints.down("sm")} {
			max-width: unset;
		}

		a.search-icon {
			cursor: default;
			&:hover {
				opacity: 0.8;
			}

			${(p) => p.theme.breakpoints.down("xs")} {
				padding: 10px 14px;
			}
		}
	}

	&&& .extension .search-input {
		width: calc(100% - 54px);
	}
`;
const SearchMobile = ({ hide, onSearch }) => {
    const { messages } = (0, shared_1.useMessages)();
    const [searchText, setSearchText] = (0, react_1.useState)("");
    const onChange = (0, react_1.useCallback)((e) => {
        setSearchText(e.currentTarget.value);
    }, [setSearchText]);
    const closeMenus = (0, shared_1.useCloseAllMenus)();
    const executeSearch = (0, react_1.useCallback)((e) => {
        if (onSearch && typeof onSearch === "function") {
            onSearch(searchText);
            setSearchText("");
            if (e && e.target) {
                e.target.blur();
            }
            closeMenus();
        }
    }, [onSearch, searchText, closeMenus]);
    const onFocus = (0, react_1.useCallback)(() => {
        //let the resize occur when mobile virtual keyboard opens or closes,
        //  then scroll to top to ensure the input is in view
        setTimeout(() => {
            window_or_global_1.default.scrollTo(0, 0);
        }, 250);
    }, []);
    const onKeyDown = (0, react_1.useCallback)((e) => {
        if (e && e.key === "Enter") {
            executeSearch(e);
        }
    }, [executeSearch]);
    if (hide)
        return null;
    return (react_1.default.createElement(Styled, null,
        react_1.default.createElement("div", { className: `extension` },
            react_1.default.createElement(atoms_1.SearchIcon, { nofocus: true, onClick: executeSearch }),
            react_1.default.createElement(Search_1.SearchInput, { className: "search-input", autoComplete: "off", type: "search", name: "keyword", id: "query", "aria-label": messages.search, placeholder: messages.search_bar, onChange: onChange, onKeyDown: onKeyDown, onSubmit: executeSearch, onFocus: onFocus, value: searchText }))));
};
exports.SearchMobile = SearchMobile;
//# sourceMappingURL=SearchMobile.js.map